import { render, staticRenderFns } from "./BlurredFeatureOverlay.vue?vue&type=template&id=87b9772e&scoped=true"
import script from "./BlurredFeatureOverlay.vue?vue&type=script&lang=js"
export * from "./BlurredFeatureOverlay.vue?vue&type=script&lang=js"
import style0 from "./BlurredFeatureOverlay.vue?vue&type=style&index=0&id=87b9772e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b9772e",
  null
  
)

export default component.exports